// extracted by mini-css-extract-plugin
export var statItem = "_cv-1";
export var statsRow = "_cv-0";